import React, { useState, useEffect } from 'react';

import {
	Alert,
	Typography,
	Space,
	Divider,
	Select,
	Button,
	message,
	Modal,
} from 'antd';
import HoursSetter from 'menuManagement/HoursSetter';
import propTypes from 'prop-types';

import {
	getParentCompanyMenus,
	massUpdateMenuHours,
} from 'menuManagement/MenuManagementHelpers';

MassUpdateMenuHours.propTypes = {
	parentCompanyData: propTypes.object.isRequired,
	parentCompanyId: propTypes.string.isRequired,
	isParent: propTypes.bool,
};
export default function MassUpdateMenuHours({
	parentCompanyData,
	parentCompanyId,
	isParent = true,
}) {
	const { Text } = Typography;

	const defaultHours = {
		ranges: [{ startTime: '09:00', endTime: '17:00' }],
		closed: false,
		open24hours: false,
	};
	const defaultWeek = {
		monday: JSON.parse(JSON.stringify(defaultHours)),
		tuesday: JSON.parse(JSON.stringify(defaultHours)),
		wednesday: JSON.parse(JSON.stringify(defaultHours)),
		thursday: JSON.parse(JSON.stringify(defaultHours)),
		friday: JSON.parse(JSON.stringify(defaultHours)),
		saturday: JSON.parse(JSON.stringify(defaultHours)),
		sunday: JSON.parse(JSON.stringify(defaultHours)),
	};
	const [hours, setHours] = useState(defaultWeek);
	const [selectedMenus, setSelectedMenus] = useState([]);
	const [allMenus, setAllMenus] = useState([]);
	const [loading, setLoading] = useState(false);
	const [responseMessage, setResponseMessage] = useState('');
	const [responseModalOpen, setResponseModalOpen] = useState(false);

	useEffect(() => {
		(async function () {
			try {
				setLoading(true);
				const menusFormattedForSelect = await getParentCompanyMenus(
					parentCompanyData,
					true,
				);
				setAllMenus(menusFormattedForSelect);
			} catch (e) {
				message.error(
					'An error occurred fetching menus. Please refresh or try again later.',
				);
				console.error(e);
			} finally {
				setLoading(false);
			}
		})();
	}, [parentCompanyData]);

	const updateHours = async () => {
		try {
			const response = await massUpdateMenuHours(
				parentCompanyId,
				hours,
				selectedMenus,
			);
			if (response.status === 200) {
				setResponseMessage(
					`Menu hours successfully updated for ${selectedMenus}`,
				);
				setResponseModalOpen(true);
			} else throw new Error();
		} catch {
			setResponseMessage('An error occurred when updating menu hours.');
			setResponseModalOpen(true);
		}
	};

	const selectAll = () => {
		setSelectedMenus(allMenus.map((menu) => menu.uuid));
	};
	const clearSelected = () => {
		setSelectedMenus([]);
	};

	const resetHours = () => setHours(defaultWeek);

	const handleModalClose = () => {
		setResponseModalOpen(false);
		setResponseMessage('');
	};

	return (
		<>
			<Space direction="vertical" size="middle">
				<Alert
					message={
						'Note that this will delete and overwrite any existing hours for the selected menus.'
					}
				/>
				<Text strong={true}>Select Menus to Apply Hours to:</Text>
				<Select
					style={{ width: '100%' }}
					mode={'multiple'}
					optionFilterProp={'label'}
					showSearch
					value={selectedMenus}
					onChange={(value) => setSelectedMenus(value)}
					loading={loading}
					placeholder={loading ? 'Loading menus' : 'Select menus'}
					options={allMenus}
				/>
				<Button loading={loading} onClick={selectAll}>
					{`Select All Menus in ${isParent ? 'Parent' : ''} Company`}
				</Button>
				<Button loading={loading} onClick={clearSelected}>
					Clear Selected
				</Button>
				<Divider />
				<Text strong={true}>Select Hours to Apply to Selected Menus:</Text>
				<HoursSetter hours={hours} setHours={setHours} />
				<Button onClick={resetHours}>Reset Hours</Button>
				<Button
					type="primary"
					loading={loading}
					disabled={!selectedMenus.length}
					onClick={updateHours}
				>
					Execute
				</Button>
			</Space>
			<Modal
				open={responseModalOpen}
				closeIcon={null}
				onOk={handleModalClose}
				onCancel={handleModalClose}
			>
				{responseMessage}
			</Modal>
		</>
	);
}
